import { send_request } from './Request';

export const retrieveConnectToken = async clientId => {
  const response = await send_request(
    `ai-service/pipedream/connectToken/${clientId}`,
    '',
    {},
    'GET'
  );
  return response?.data;
};

export const deletePipedreamCredential = async credentialId => {
  return await send_request(
    `ai-service/pipedream/credential/delete/${credentialId}`,
    '',
    {},
    'DELETE'
  ).then(res => {
    if (!res.status) {
      throw new Error(res);
    }
  });
};
